import {
  ActionLabel,
  GoogleIntegrationActions,
  Integrations,
} from "./constants";
import logoSmartSuite from "../../generated/images/LogoSmartsuite";
import logoSlack from "../../generated/images/LogoSlack";
import logoTwilio from "../../generated/images/LogoTwillo";
import logoGoogle from "../../generated/images/LogoGoogle";
import logoGmail from "../../generated/images/LogoGmail";
import LogoDefault from "../../generated/images/LogoDefault";
import logoFindRecords from "../../generated/images/LogoFindRecords";
import logoMerge from "../../generated/images/LogoMerge";
import logoGoogleSheets from "../../generated/images/LogoGoogleSheets";
import logoGoogleDrive from "../../generated/images/LogoGoogleDrive";
import logoOutlook from "../../generated/images/LogoOutlook";
import logoGoogleCalendar from "../../generated/images/LogoGoogleCalendar";
import logoSalesforce from "../../generated/images/LogoSalesforce";
import logoIntercom from "../../generated/images/LogoIntercom";
import logoHubspot from "../../generated/images/LogoHubspot";
import logoMicrosoftTeams from "../../generated/images/LogoMicrosoftTeams";
import logoMonday from "../../generated/images/LogoMonday";
import logoJira from "../../generated/images/LogoJira";
import { LogoAi, LogoGeneratePdf } from "../../generated/images";
import logoWebhook from "../../generated/images/LogoWebhook";
import logoDocsautomator from "../../generated/images/LogoDocsautomator";
import type { SVGTag } from "./get-svg";

export const getIntegrationLogo = (
  integrationId: string,
  actionId?: string,
): SVGTag => {
  switch (true) {
    case integrationId.startsWith(Integrations.smartsuite) ||
      integrationId.startsWith(Integrations.generatePdf) ||
      integrationId === Integrations.loop: {
      if (actionId === undefined) {
        return logoSmartSuite;
      }

      switch (actionId) {
        case ActionLabel.findRecords:
          return logoFindRecords;
        case ActionLabel.mergeRecords:
          return logoMerge;
        case ActionLabel.generatePdf:
          return LogoGeneratePdf;
        case ActionLabel.loop:
        default:
          return logoSmartSuite;
      }
    }

    case integrationId.startsWith(Integrations.microsoft) &&
      integrationId.includes(Integrations.outlook):
      return logoOutlook;
    case integrationId === Integrations.o365:
    case integrationId === Integrations.outlook:
      return logoOutlook;
    case integrationId === Integrations.jira:
      return logoJira;
    case integrationId === Integrations.salesforce:
      return logoSalesforce;
    case integrationId === Integrations.intercom:
      return logoIntercom;
    case integrationId === Integrations.hubspot:
      return logoHubspot;
    case integrationId === Integrations.microsoftTeams:
    case integrationId === Integrations.msTeams:
      return logoMicrosoftTeams;
    case integrationId === Integrations.monday:
      return logoMonday;
    case integrationId.startsWith(Integrations.slack):
      return logoSlack;
    case integrationId.startsWith(Integrations.twilio):
      return logoTwilio;
    case integrationId === Integrations.webhooks:
      return logoWebhook;
    case integrationId.startsWith(Integrations.google):
      switch (true) {
        case integrationId === Integrations.googlesheets:
          return logoGoogleSheets;
        case integrationId === Integrations.googledrive:
          return logoGoogleDrive;
        case integrationId === Integrations.googlecalendar:
          return logoGoogleCalendar;
        case integrationId.includes(GoogleIntegrationActions.gmail):
          return logoGmail;
        default:
          return logoGoogle;
      }
    case integrationId.startsWith(Integrations.ai):
      return LogoAi;
    case integrationId.startsWith(Integrations.docsautomator):
      return logoDocsautomator;
    default:
      return LogoDefault;
  }
};
